module.exports = __webpack_public_path__ + "img/warehouse-3.8ba54396.jpg";